import { pipe, prop } from 'lodash/fp';

import {
	PROP_IS_LOGGED_IN,
	PROP_IS_LOGGING_OUT,
	PROP_USER_ACCOUNT_TYPE,
	PROP_USER_ID,
	_MODULE_NAME,
} from './constants';

const rootReducer = prop(_MODULE_NAME);

export const isLoggedInSelector = pipe(rootReducer, prop(PROP_IS_LOGGED_IN));

export const isLoggingOutSelector = pipe(rootReducer, prop(PROP_IS_LOGGING_OUT));

export const userAccountTypeSelector = pipe(rootReducer, prop(PROP_USER_ACCOUNT_TYPE));

export const userIdSelector = pipe(rootReducer, prop(PROP_USER_ID));
